export class ProfilePhoto {
    constructor() {
        console.log('ProfilePhoto constructor called');

        // Don't try to access DOM elements in constructor
        this.initialized = false;
        this.centerX = window.innerWidth / 2;
        this.centerY = window.innerHeight / 2;
        this.maxDistance = 20;
        this.lastClickTime = 0;
        this.consecutiveClicks = 0;
        this.longPressTimer = null;
        this.longPressDuration = 500;
        this.nfts = [];
        this.currentNftIndex = 0;
        this.cycleInterval = null;
    }

    async init() {
        try {

            // Initialize DOM elements
            this.outerContainer = document.getElementById('profileOuterContainer');
            this.innerContainer = document.getElementById('profileInnerContainer');
            this.photo = document.getElementById('profilePhoto');
            this.tipText = document.getElementById('tipText');
            this.clickSound = document.getElementById('clickSound');


            console.log("ProfilePhoto Img", this.photo);
            // Debug logging
            if (!this.outerContainer) console.error('profileOuterContainer not found');
            if (!this.innerContainer) console.error('profileInnerContainer not found');
            if (!this.photo) console.error('profilePhoto not found');
            if (!this.tipText) console.error('tipText not found');
            if (!this.clickSound) console.warn('clickSound not found - sound effects will be disabled');

            // Only check required elements
            if (!this.outerContainer || !this.innerContainer || !this.photo) {
                throw new Error('Required DOM elements not found');
            }

            // Add event listeners
            this.bindEvents();

            // Check for NFT background while preserving current background
            const metadata = await this.fetchUserNFTs();

            // Set initial NFT if available
            if (this.nfts.length > 0) {
                this.currentNftIndex = 0;
                this.setCurrentNFT();
                this.startAutoCycle();
            }

            this.initialized = true;
            return metadata;

        } catch (error) {
            console.error('Error initializing ProfilePhoto:', error);
            return null;
        }
    }

    bindEvents() {
        if (this.innerContainer) {
            this.innerContainer.addEventListener('click', e => this.onClick(e));
        }

        if (this.tipText) {
            this.tipText.addEventListener('click', e => this.onTipClick(e));
        }

        window.addEventListener('mousemove', e => this.onMouseMove(e));
        window.addEventListener('resize', () => this.onResize());
    }

    handleMouseDown(e) {
        this.longPressTimer = setTimeout(() => {
            this.startCyclingNFTs();
        }, this.longPressDuration);
    }

    handleMouseUp() {
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
            this.longPressTimer = null;
        }
        this.stopCyclingNFTs();
    }

    startAutoCycle() {
        if (this.nfts.length <= 1) return;

        this.cycleInterval = setInterval(() => {
            this.currentNftIndex = (this.currentNftIndex + 1) % this.nfts.length;
            this.setCurrentNFT();
        }, 10000); // Cycle every 10 second
    }

    cleanup() {

        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
        }
        if (this.cycleInterval) {
            clearInterval(this.cycleInterval);
        }
        if (this.photo) {
            this.photo.removeEventListener('mousedown', this.handleMouseDown);
            this.photo.removeEventListener('mouseup', this.handleMouseUp);
            this.photo.removeEventListener('mouseleave', this.handleMouseUp);
            this.photo.removeEventListener('touchstart', this.handleMouseDown);
            this.photo.removeEventListener('touchend', this.handleMouseUp);
            this.photo.removeEventListener('contextmenu', (e) => e.preventDefault());
        }

        // Remove event listeners
        this.removeEventListeners();
        // Clear any timers or intervals
        this.clearTimers();
        // Reset any state
        this.resetState();
    }

    removeEventListeners() {
        // Remove all event listeners you added
        const photo = document.getElementById('profilePhoto');
        if (photo) {
            photo.removeEventListener('click', this.handleClick);
            // ... remove other listeners
        }
    }

    clearTimers() {
        // Clear any setInterval or setTimeout
        if (this.someTimer) {
            clearTimeout(this.someTimer);
        }
    }

    resetState() {
        // Reset any internal state variables
        this.isAnimating = false;
        // ... reset other state
    }

    getAddressFromSubdomain() {
        try {
            // Get the hostname (e.g., "SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5.gated.so")
            const hostname = window.location.hostname;
            console.log('Current hostname:', hostname);

            // Split by dots and get the first part (the subdomain/address)
            const subdomain = hostname.split('.')[0].toUpperCase();
            console.log('Extracted subdomain:', subdomain);

            // Validate that it's a Stacks address
            if (subdomain.startsWith('SP') || subdomain.startsWith('ST')) {
                console.log('Valid Stacks address found:', subdomain);
                return subdomain;
            }

            console.error('Invalid Stacks address format:', subdomain);
            throw new Error(`Invalid Stacks address in subdomain: ${subdomain}`);
        } catch (error) {
            console.error('Error getting address from subdomain:', error);
            throw error;
        }
    }

    async checkForNFTBackground() {
        if (!this.photo) {
            console.error('Photo element not found');
            return;
        }

        const stxAddress = this.getAddressFromSubdomain().toUpperCase();
        const maxAttempts = 100;
        const nftHoldingsUrl = `/api/proxy/stacks?principal=${stxAddress}&limit=${maxAttempts}`;

        try {
            const holdingsResponse = await fetch(nftHoldingsUrl);
            const holdingsData = await holdingsResponse.json();
            console.log('Holdings data MAINNET:', holdingsData);

            if (holdingsData.results && holdingsData.results.length > 0) {
                for (let i = 0; i < Math.min(maxAttempts, holdingsData.results.length); i++) {
                    const nft = holdingsData.results[i];
                    console.log(`Checking NFT For Profile Background MAINNET ${i + 1}:`, nft);

                    const [contractAddress, assetName] = nft.asset_identifier.split('::');
                    const tokenId = nft.value && nft.value.repr ? parseInt(nft.value.repr.replace(/^u/, '')) : null;

                    if (!tokenId) {
                        console.error('Failed to parse token ID MAINNET:', nft.value);
                        continue;
                    }

                    try {
                        const metadataUrl = `https://api.hiro.so/metadata/v1/nft/${contractAddress}/1`;
                        console.log('Fetching metadata from MAINNET:', metadataUrl);

                        const metadataResponse = await fetch(metadataUrl);
                        const metadata = await metadataResponse.json();
                        console.log('Metadata MAINNET:', metadata);

                        const correctTitle = metadata?.metadata?.name;
                        if (!correctTitle) continue;

                        const options = {
                            contractAddress: 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5',
                            contractName: 'gated-pages',
                            functionName: 'get-page-by-title',
                            functionArgs: [
                                principalCV(stxAddress),
                                stringAsciiCV(correctTitle)
                            ],
                            network: STACKS_MAINNET,
                            senderAddress: stxAddress
                        };

                        const pageResult = await fetchCallReadOnlyFunction(options);
                        console.log('Page result:', pageResult);

                        if (pageResult?.value?.value) {
                            // Extract values from the page result
                            const pageData = pageResult.value.value;
                            const title = pageData.title.value;
                            const description = pageData.description.value;
                            const pageId = Number(pageData.id.value);

                            console.log('Extracted values:', { title, description, pageId });

                            // Get token URI
                            const tokenUriOptions = {
                                contractAddress: 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5',
                                contractName: 'gated-pages',
                                functionName: 'get-token-uri',
                                functionArgs: [uintCV(pageId)],
                                network: STACKS_MAINNET,
                                senderAddress: stxAddress
                            };

                            const tokenUriResult = await fetchCallReadOnlyFunction(tokenUriOptions);
                            console.log('Token URI result:', tokenUriResult);

                            if (tokenUriResult?.value?.value?.value) {
                                const ipfsUri = tokenUriResult.value.value.value; // This gets the actual IPFS URL string
                                const httpUrl = ipfsUri.replace('ipfs://', 'https://ipfs.io/ipfs/');
                                try {
                                    const updatedMetadataResponse = await fetch(httpUrl);
                                    const updatedMetadata = await updatedMetadataResponse.json();
                                    console.log('Updated metadata from IPFS:', updatedMetadata);


                                    // Set background image if NFT image exists
                                    const cachedImageUrl = metadata?.metadata?.cached_image;
                                    if (cachedImageUrl && await this.isValidImageUrl(cachedImageUrl)) {
                                        this.photo.style.backgroundImage = `url('${cachedImageUrl}')`;
                                        console.log('NFT image set as background MAINNET:', cachedImageUrl);
                                        return updatedMetadata;
                                    }
                                } catch (error) {
                                    console.error('Error processing NFT:', error);
                                    continue
                                }
                            }
                        }
                    } catch (error) {
                        console.error('Error processing NFT:', error);
                        continue;
                    }
                }
                console.log('No valid NFT images found after checking up to 3 NFTs MAINNET');
            } else {
                console.log('No NFTs found for the address MAINNET');
            }
        } catch (error) {
            console.error('Error fetching holdings:', error);
            return null;
        }
    }

    async onLongPress(e) {
        e.preventDefault();
        await this.fetchUserNFTs();
        this.showNFTModal();
    }

    async fetchUserNFTs() {
        const userAddress = this.getAddressFromSubdomain().toUpperCase();
        const nftHoldingsUrl = `/api/proxy/stacks?principal=${userAddress}&limit=50`;

        try {
            const holdingsResponse = await fetch(nftHoldingsUrl);
            if (!holdingsResponse.ok) {
                throw new Error(`HTTP error! status: ${holdingsResponse.status}`);
            }
            const holdingsData = await holdingsResponse.json();
            console.log('Holdings data:', holdingsData);

            if (holdingsData.results && holdingsData.results.length > 0) {
                const sortedNFTs = holdingsData.results.sort((a, b) => b.block_height - a.block_height);
                const validNFTs = [];

                for (const nft of sortedNFTs) {
                    try {
                        console.log(`Processing NFT:`, nft);

                        const [contractAddress, assetName] = nft.asset_identifier.split('::');
                        const tokenId = nft.value && nft.value.repr ? parseInt(nft.value.repr.replace(/^u/, '')) : null;

                        if (!tokenId) {
                            console.log('Skipping NFT (invalid token ID):', nft.value);
                            continue;
                        }

                        const metadataUrl = `https://api.hiro.so/metadata/v1/nft/${contractAddress}/1`;
                        console.log('Fetching metadata from:', metadataUrl);

                        const metadataResponse = await fetch(metadataUrl);
                        if (!metadataResponse.ok) {
                            console.log(`Metadata fetch failed for ${metadataUrl}:`, metadataResponse.status);
                            continue;
                        }

                        const metadata = await metadataResponse.json();
                        console.log('Successfully fetched metadata:', metadata);

                        // Try different possible image URL fields
                        const imageUrl = metadata?.metadata?.cached_image ||
                            metadata?.metadata?.image ||
                            metadata?.metadata?.image_url;

                        if (!imageUrl) {
                            console.log('No image URL found in metadata');
                            continue;
                        }

                        // Validate image URL
                        const isValid = await this.isValidImageUrl(imageUrl);
                        if (!isValid) {
                            console.log('Invalid image URL:', imageUrl);
                            continue;
                        }

                        // Add valid NFT to array
                        validNFTs.push({
                            id: tokenId,
                            imageUrl: imageUrl,
                            name: metadata?.metadata?.name || `NFT #${tokenId}`,
                            blockHeight: nft.block_height
                        });

                    } catch (error) {
                        console.error('Error processing individual NFT:', error);
                        console.error('NFT that caused error:', nft);
                        continue;
                    }
                }

                this.nfts = validNFTs;
                console.log('Final valid NFTs:', this.nfts);

            } else {
                console.log('No NFTs found for the address');
                this.nfts = [];
            }

        } catch (error) {
            console.error('Error in fetchUserNFTs:', error);
            console.error('Error stack:', error.stack);
            this.nfts = [];
        }
    }
    async isValidImageUrl(url) {
        try {
            const response = await fetch(url, { method: 'HEAD' });
            return response.ok && response.headers.get('Content-Type').startsWith('image/');
        } catch (error) {
            console.error('Error validating image URL:', error);
            return false;
        }
    }

    async showNFTModal() {
        await this.fetchUserNFTs();

        if (this.nfts.length === 0) {
            alert("No suitable NFTs found for profile picture.");
            return;
        }

        const modal = document.createElement('div');
        modal.classList.add('nft-modal');
        modal.innerHTML = `
        <div class="nft-modal-content">
            <span class="close-modal">&times;</span>
            <h2>Choose NFT for Profile</h2>
            <div class="nft-display">
                <button class="nav-button prev">&lt;</button>
                <div class="nft-image-container">
                    <img src="${this.nfts[0].imageUrl}" alt="${this.nfts[0].name}" class="nft-image">
                </div>
                <button class="nav-button next">&gt;</button>
            </div>
            <p class="nft-name">${this.nfts[0].name}</p>
            <button class="select-nft">Select as Profile Photo</button>
        </div>
    `;

        document.body.appendChild(modal);

        const closeBtn = modal.querySelector('.close-modal');
        const prevBtn = modal.querySelector('.nav-button.prev');
        const nextBtn = modal.querySelector('.nav-button.next');
        const selectBtn = modal.querySelector('.select-nft');

        closeBtn.onclick = () => modal.remove();
        prevBtn.onclick = () => this.navigateNFT('prev');
        nextBtn.onclick = () => this.navigateNFT('next');
        selectBtn.onclick = () => this.selectNFT();

        this.currentNftIndex = 0;
        this.updateNFTDisplay();
    }



    navigateNFT(direction) {
        if (direction === 'next') {
            this.currentNftIndex = (this.currentNftIndex + 1) % this.nfts.length;
        } else {
            this.currentNftIndex = (this.currentNftIndex - 1 + this.nfts.length) % this.nfts.length;
        }
        this.updateNFTDisplay();
    }

    getNFTContent(nft) {
        if (nft.imageUrl) {
            return `<img src="${nft.imageUrl}" alt="${nft.name}" class="nft-image">`;
        } else if (typeof nft.id === 'string') {
            // This is likely a BNS name
            return `<div class="bns-name">${nft.id}</div>`;
        } else {
            return `<div class="nft-placeholder">No image available</div>`;
        }
    }

    updateNFTDisplay() {
        const nftImage = document.querySelector('.nft-image');
        const nftName = document.querySelector('.nft-name');
        const currentNFT = this.nfts[this.currentNftIndex];
        nftImage.src = currentNFT.imageUrl;
        nftImage.alt = currentNFT.name;
        nftName.textContent = currentNFT.name;
    }

    navigateNFT(direction) {
        if (direction === 'next') {
            this.currentNftIndex = (this.currentNftIndex + 1) % this.nfts.length;
        } else {
            this.currentNftIndex = (this.currentNftIndex - 1 + this.nfts.length) % this.nfts.length;
        }
        this.updateNFTDisplay();
    }

    selectNFT() {
        const selectedNFT = this.nfts[this.currentNftIndex];
        this.photo.style.backgroundImage = `url('${selectedNFT.imageUrl}')`;
        document.querySelector('.nft-modal').remove();
    }

    onClick(e) {
        const currentTime = new Date().getTime();
        const timeSinceLastClick = currentTime - this.lastClickTime;

        if (timeSinceLastClick < 500) {
            this.consecutiveClicks++;
            if (this.consecutiveClicks >= 1) {
                this.showTip();
            }
        } else {
            this.consecutiveClicks = 1;
        }

        this.lastClickTime = currentTime;

        this.createWave(e);
        this.createFloatingEmoji(e);

        // Add safe sound handling
        if (this.clickSound) {
            try {
                this.clickSound.currentTime = 0;
                this.clickSound.play().catch(err => {
                    console.log('Could not play click sound:', err);
                });
            } catch (err) {
                console.log('Error with click sound:', err);
            }
        }
    }

    // Helper function to validate image URL
    async isValidImageUrl(url) {
        try {
            const response = await fetch(url, { method: 'HEAD' });
            return response.ok && response.headers.get('Content-Type').startsWith('image/');
        } catch (error) {
            console.error('Error validating image URL:', error);
            return false;
        }
    }

    createWave(e) {
        const wave = document.createElement('div');
        wave.classList.add('wave');
        this.innerContainer.appendChild(wave);

        const rect = this.innerContainer.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        wave.style.width = wave.style.height = `${size}px`;
        wave.style.left = `${x}px`;
        wave.style.top = `${y}px`;

        wave.style.animation = 'ripple 0.1s linear';
        wave.addEventListener('animationend', () => {
            wave.remove();
        });
    }

    showTip() {
        this.photo.classList.add('tipped');
        this.tipText.classList.add('show');
        setTimeout(() => {
            this.photo.classList.remove('tipped');
            this.tipText.classList.remove('show');
        }, 5000); // Show the tip text for 5 seconds
    }

    async onTipClick(e, recipientAddress) {
        e.stopPropagation();
        console.log('Tip clicked! Ready to interact with smart contract.');

        // Get router instance
        const router = window.router;
        if (!router || !router.auth) {
            console.error('Router or auth service not available');
            return;
        }


        // Check if the user is signed in
        if (!router.auth.isSignedIn()) {
            console.log('User is not signed in, initiating wallet connection');
            try {
                // Use the auth service instead of direct showConnect
                await router.auth.connectWallet(false);
                const userData = userSession.loadUserData();
                const userAddressMainnet = userData.profile.stxAddress.mainnet;
                const userAddressTestnet = userData.profile.stxAddress.testnet;

                const shortAddressMainnet = formatAccountNumber(userAddressMainnet);
                const shortAddressTestnet = formatAccountNumber(userAddressTestnet);


                console.log('Authenticated as:', userData);
                console.log('STX Address:', shortAddressMainnet);

            } catch (error) {
                console.error('Failed to connect wallet:', error);
                return;
            }
        }

        try {
            const userData = router.auth.userSession.loadUserData();
            console.log('User data:', userData);

            if (!userData || !userData.profile || !userData.profile.stxAddress) {
                console.error('User data is incomplete');
                return;
            }
            const senderAddress = userData.profile.stxAddress.mainnet;

            function getAddressFromSubdomain() {
                try {
                    // Get the hostname (e.g., "SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5.gated.so")
                    const hostname = window.location.hostname;
                    console.log('Current hostname:', hostname);

                    // Split by dots and get the first part (the subdomain/address)
                    const subdomain = hostname.split('.')[0].toUpperCase();
                    console.log('Extracted subdomain:', subdomain);

                    // Validate that it's a Stacks address
                    if (subdomain.startsWith('SP') || subdomain.startsWith('ST')) {
                        console.log('Valid Stacks address found:', subdomain);
                        return subdomain;
                    }

                    console.error('Invalid Stacks address format:', subdomain);
                    throw new Error(`Invalid Stacks address in subdomain: ${subdomain}`);
                } catch (error) {
                    console.error('Error getting address from subdomain:', error);
                    throw error;
                }
            }

            // Usage with error handling
            let recipientAddress;
            try {
                recipientAddress = getAddressFromSubdomain();
                console.log('Recipient address set to:', recipientAddress);
            } catch (error) {
                console.error('Failed to get recipient address:', error);
                // Handle the error appropriately
                // Maybe set a default address or show an error message
            }

            console.log('Setting up 1 STX tip. Getting Sender and Recipient information...');
            console.log('Sender address:', senderAddress);
            console.log('Recipient address:', recipientAddress);

            // Define the tip amount (should match the amount in your contract)
            const tipAmount = 1000000; // 1 STX in microSTX

            // Prepare the contract call
            const functionArgs = [
                principalCV(recipientAddress)
            ];


            const postConditions =
                [Pc.principal(senderAddress).willSendEq(tipAmount).ustx()]

            const options = {
                contractAddress: 'SP1ZCYG0D3HCK2F7SY8VH9ZREB0JWCBSAPFNS8V5Z',
                contractName: 'squealing-white-toucan',
                functionName: 'tip',
                functionArgs,
                network: STACKS_MAINNET,
                postConditions,
                onFinish: data => {
                    console.log('Transaction finished:', data);
                },
                onCancel: () => {
                    console.log('Transaction was canceled');
                }
            };

            console.log('Contract call options:', options);

            await openContractCall(options);
        } catch (error) {
            console.error('Error in onTipClick:', error);
        }
    }

    // Placeholder for future smart contract interaction
    sendTip(amount) {
        // This method would contain the logic to interact with your smart contract
        console.log(`Sending tip of ${amount} STX`);
        // Implement your smart contract interaction here
    }

    createFloatingEmoji(e) {
        const emoji = document.createElement('div');
        emoji.classList.add('floating-emoji');
        emoji.textContent = '💐';

        const rect = this.innerContainer.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        emoji.style.left = `${x}px`;
        emoji.style.top = `${y}px`;

        this.outerContainer.appendChild(emoji);

        emoji.addEventListener('animationend', () => {
            emoji.remove();
        });
    }

    onMouseMove(e) {
        if (!this.outerContainer) return;

        const distanceX = e.clientX - this.centerX;
        const distanceY = e.clientY - this.centerY;
        const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
        const maxDistance = Math.min(window.innerWidth, window.innerHeight) / 2;
        const moveX = (distanceX / maxDistance) * this.maxDistance;
        const moveY = (distanceY / maxDistance) * this.maxDistance;

        requestAnimationFrame(() => {
            if (this.outerContainer) {
                this.outerContainer.style.transform = `translate(${moveX}px, ${moveY}px)`;
            }
        });
    }

    onResize() {
        this.centerX = window.innerWidth / 2;
        this.centerY = window.innerHeight / 2;
    }
}